import filter from 'lodash/filter';
import get from 'lodash/get';
import size from 'lodash/size';
import defaultFields from 'store/Host/contextFields';
import { updatePreferences } from 'store/Preferences/actions';
import { selectFields } from './contextSelectors';

export function setFieldVisibility (field, value) {
  return async (dispatch, getState) => {
    let host_table = selectFields(getState());

    if (!host_table) host_table = { ...defaultFields };
    if (!host_table[field].locked) {
      host_table[field].visible = value;

      if (value) host_table[field].order = Object.keys(host_table).filter((key) => host_table[key].visible).length;
      else {
        let cont = 1;
        Object.keys(host_table).filter((f) => host_table[f].visible).sort((a, b) => (host_table[a].order < host_table[b].order)).forEach((f2) => {
          host_table[f2].order = cont;
          cont += 1;
        });
      }

      dispatch(updatePreferences({ host_table }));
    }
  };
}

export function setNewOrderColumns (columns) {
  return async (dispatch, getState) => {
    let host_table = selectFields(getState());
    if (!host_table) host_table = { ...defaultFields };

    const fixedColumns = size(filter(host_table, { locked: true }));

    columns.forEach((column) => {
      if (column) {
        if (!get(host_table, `${column}.locked`, false)) {
          host_table[column].order = columns.indexOf(column) + 1 + fixedColumns;
        }
      }
    });

    dispatch(updatePreferences({ host_table }));
  };
}

export function resetDefault () {
  return async (dispatch) => {
    dispatch(updatePreferences({ host_table: defaultFields }));
  };
}
